import { IconProps } from '../Icons.type'

export function SantanderCircleIcon(props: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#F3123C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8393 22.6571C31.7853 21.5041 31.4384 20.3602 30.7963 19.3263L25.1327 10.2054C24.7008 9.50963 24.4025 8.76444 24.2367 8L24.0002 8.38121C22.5981 10.6387 22.5981 13.42 24 15.6775L28.5309 22.9743C29.9328 25.2321 29.9328 28.0136 28.5309 30.2711L28.2942 30.6523C28.1286 29.8879 27.8301 29.1427 27.3982 28.4472L20.6018 17.5019C20.1702 16.8064 19.8717 16.061 19.706 15.2968L19.4694 15.678C18.0723 17.9279 18.068 20.698 19.4554 22.9515L19.4552 22.9517L24.0002 30.2711C25.4019 32.5286 25.4019 35.3102 24.0002 37.5679L23.7634 37.9491C23.5977 37.1847 23.2994 36.4395 22.8675 35.7438L17.2039 26.6228C16.4444 25.3995 16.0972 24.0224 16.1608 22.6583C10.098 24.131 5.91306 27.2583 5.91306 30.8793C5.91306 35.9166 14.0111 40 24.0002 40C33.9891 40 42.087 35.9166 42.087 30.8793C42.087 27.2581 37.9025 24.1301 31.8393 22.6571Z"
        fill="#F3123C"
      />
    </svg>
  )
}
